/**
 * Turn a string with multiple values separated with commas into an array
 * @param str
 * @returns
 */
export const multiValuesStringToArray = (str: string) => {
  const splited = str.toLowerCase().split(',');
  return splited.map(v => v.trim()).filter(v => v.length > 0);
};
